import { FC, ReactElement, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { isEmpty } from 'lodash';

import { DateFilters, facet } from '@app/components';
import { useSearchContext } from '@app/contexts';
import { sharedMessages } from '@app/translations';

import { Facet } from '../Facet';

interface PublicationYearFacetProps {
  dateFacetCount: number;
  setDateFacetCount: (count: number) => void;
}

export const PublicationYearFacet: FC<PublicationYearFacetProps> = ({
  dateFacetCount,
  setDateFacetCount,
}) => {
  const { $t } = useIntl();
  const { selectedPublicationYear, setSelectedPublicationYear } =
    useSearchContext();

  const dateFiltersLabel = $t(sharedMessages.publicationYear);

  useEffect(() => {
    setDateFacetCount(!isEmpty(selectedPublicationYear) ? 1 : 0);
  }, [selectedPublicationYear, setDateFacetCount]);

  return (
    <Facet
      label={dateFiltersLabel}
      facetKey={facet.publication_year}
      selectedCount={dateFacetCount}
      isInitiallyExpanded={dateFacetCount > 0}
      facetAttributes={
        (
          <DateFilters
            ariaLabel={dateFiltersLabel}
            selectedDateRange={selectedPublicationYear}
            onDateRangeChange={setSelectedPublicationYear}
          />
        ) as unknown as ReactElement[]
      }
    />
  );
};
